import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';
import Button from '../../../components/ui/Button';

const HeroCarousel = () => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const navigate = useNavigate();

  const featuredEvents = [
    {
      id: 1,
      title: "Summer Music Festival 2024",
      venue: "Central Park",
      date: "July 15, 2024",
      time: "6:00 PM",
      image: "https://images.unsplash.com/photo-1459749411175-04bf5292ceea?w=800&h=400&fit=crop",
      startingPrice: 45,
      description: "Join us for an unforgettable evening of live music featuring top artists from around the world."
    },
    {
      id: 2,
      title: "Comedy Night Spectacular",
      venue: "Madison Square Garden",
      date: "August 2, 2024",
      time: "8:00 PM",
      image: "https://images.pexels.com/photos/713149/pexels-photo-713149.jpeg?w=800&h=400&fit=crop",
      startingPrice: 35,
      description: "Laugh until your sides hurt with the best comedians in the business."
    },
    {
      id: 3,
      title: "Food & Wine Experience",
      venue: "Brooklyn Bridge Park",
      date: "September 10, 2024",
      time: "2:00 PM",
      image: "https://images.pixabay.com/photo/2017/08/03/21/48/drinks-2578446_1280.jpg?w=800&h=400&fit=crop",
      startingPrice: 65,
      description: "Savor exquisite cuisine and fine wines from renowned chefs and vintners."
    }
  ];

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % featuredEvents?.length);
    }, 5000);

    return () => clearInterval(timer);
  }, [featuredEvents?.length]);

  const goToSlide = (index) => {
    setCurrentSlide(index);
  };

  const nextSlide = () => {
    setCurrentSlide((prev) => (prev + 1) % featuredEvents?.length);
  };

  const prevSlide = () => {
    setCurrentSlide((prev) => (prev - 1 + featuredEvents?.length) % featuredEvents?.length);
  };

  const handleEventClick = (eventId) => {
    navigate('/event-detail', { state: { eventId } });
  };

  const currentEvent = featuredEvents?.[currentSlide];

  return (
    <div className="relative bg-card rounded-lg shadow-elevation-2 overflow-hidden mb-8">
      <div className="relative h-64 sm:h-80 lg:h-96">
        <Image
          src={currentEvent?.image}
          alt={currentEvent?.title}
          className="w-full h-full object-cover"
        />
        
        {/* Overlay */}
        <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent" />
        
        {/* Content */}
        <div className="absolute bottom-0 left-0 right-0 p-6 text-white">
          <div className="max-w-2xl">
            <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold mb-2">
              {currentEvent?.title}
            </h2>
            <p className="text-sm sm:text-base opacity-90 mb-3">
              {currentEvent?.description}
            </p>
            <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
              <div className="space-y-1">
                <div className="flex items-center space-x-2 text-sm">
                  <Icon name="MapPin" size={16} />
                  <span>{currentEvent?.venue}</span>
                </div>
                <div className="flex items-center space-x-2 text-sm">
                  <Icon name="Calendar" size={16} />
                  <span>{currentEvent?.date} at {currentEvent?.time}</span>
                </div>
                <div className="flex items-center space-x-2 text-sm">
                  <Icon name="DollarSign" size={16} />
                  <span>Starting at ${currentEvent?.startingPrice}</span>
                </div>
              </div>
              <Button
                variant="default"
                size="lg"
                onClick={() => handleEventClick(currentEvent?.id)}
                className="bg-primary hover:bg-primary/90 text-primary-foreground"
              >
                Get Tickets
              </Button>
            </div>
          </div>
        </div>

        {/* Navigation Arrows */}
        <button
          onClick={prevSlide}
          className="absolute left-4 top-1/2 -translate-y-1/2 w-10 h-10 bg-black/50 hover:bg-black/70 rounded-full flex items-center justify-center text-white transition-colors"
        >
          <Icon name="ChevronLeft" size={20} />
        </button>
        <button
          onClick={nextSlide}
          className="absolute right-4 top-1/2 -translate-y-1/2 w-10 h-10 bg-black/50 hover:bg-black/70 rounded-full flex items-center justify-center text-white transition-colors"
        >
          <Icon name="ChevronRight" size={20} />
        </button>
      </div>
      {/* Indicators */}
      <div className="absolute bottom-4 left-1/2 -translate-x-1/2 flex space-x-2">
        {featuredEvents?.map((_, index) => (
          <button
            key={index}
            onClick={() => goToSlide(index)}
            className={`w-2 h-2 rounded-full transition-colors ${
              index === currentSlide ? 'bg-white' : 'bg-white/50'
            }`}
          />
        ))}
      </div>
    </div>
  );
};

export default HeroCarousel;